import { fetcher } from "@website/fetcher/fetcher";
import {
  ResetPasswordRequestOtpBodyType,
  ResetPasswordRequestOtpResponseType
} from "@website/widget/login/services/reset-password-request-otp/reset-password-request-otp.types";

export const ResetPasswordRequestOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/reset-password/request-otp`;

export const ResetPasswordRequestOtpService = (
  body: ResetPasswordRequestOtpBodyType
): Promise<ResetPasswordRequestOtpResponseType> =>
  fetcher({
    url: ResetPasswordRequestOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
